import * as React from 'react';

function SvgArrowYen(props) {
  return (
    <svg
      width={41.016}
      height={284}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        stroke="#cfcfcf"
        strokeWidth={3}
        strokeLinecap="round"
        d="M5.095 141.5h11"
      />
      <path
        stroke="#cfcfcf"
        strokeWidth={5}
        d="M11.168 17.011l-1.073 249.997"
      />
      <path
        d="M10.229.5a1 1 0 011.732 0l9.093 15.75a1 1 0 01-.866 1.5H2.001a1 1 0 01-.866-1.5zM10.96 283.5a1 1 0 01-1.731 0L.135 267.75a1 1 0 01.866-1.5h18.187a1 1 0 01.866 1.5z"
        fill="#cfcfcf"
      />
      <path
        d="M22.3466 137.273L24.5795 142.131L23.7614 142.472L21.1705 137.273H22.3466ZM24 142.131L26.233 137.273H27.4091L24.8182 142.472L24 142.131ZM24.8182 141.415V146H23.7614V141.415H24.8182ZM26.7273 141.653V142.42H21.8523V141.653H26.7273ZM26.7273 143.341V144.108H21.8523V143.341H26.7273ZM31.5458 137.273V146H30.489V138.381H30.4379L28.3072 139.795V138.722L30.489 137.273H31.5458Z"
        fill="#818181"
      />
    </svg>
  );
}

export default SvgArrowYen;
